import React from 'react';
import { Box } from '@mui/material';
import { useMutation } from 'react-query';
import axios from 'api/request';
import { endPoints } from 'api/endpoints';
import PropTypes from 'prop-types';
import Select from 'pages/reference-implementation/components/select';
import ProvisioningStyles from 'pages/provisioning/kafka/style';

const Cluster = (props) => {
    const { order, clusterValue, handleOnSelect, isRequired } = props;
    const [options, setOptions] = React.useState([]);
    const clusterApi = useMutation((payload) => axios.post(endPoints.aws.lookups.eksClusterDetails, payload));

    const selectedValueExistsInOptions = (value) => options?.find((option) => value === option?.value);

    const handleOnSelectChange = (selected) => {
        if (selectedValueExistsInOptions(selected?.value)) {
            handleOnSelect(selected?.value, selected);
        }
    };

    React.useEffect(() => {
        if (clusterApi?.isSuccess) {
            setOptions(
                clusterApi?.data?.data?.clusters?.map((app) => ({
                    label: app.eksClusterName,
                    value: app.eksClusterName,
                    data: app,
                }))
            );
        }
    }, [clusterApi?.isSuccess]);

    React.useEffect(() => {
        if (options && options?.length === 1 && !clusterValue) {
            handleOnSelect(options?.[0].value, options?.[0]);
        }
    }, [options]);

    React.useEffect(() => {
        setOptions([]);
        if (order?.sector && order?.environment && order?.eksDepartment && order?.program) {
            clusterApi.mutate({
                sector: order?.sector,
                environment: order?.environment,
                department: order?.eksDepartment,
                applicationRegion: order?.appRegion,
                program: order?.program,
            });
        }
    }, [order?.sector, order?.environment, order?.eksDepartment, order?.appRegion, order?.program]);

    return (
        <Box sx={ProvisioningStyles.box}>
            <Select
                key="cluster"
                label="Cluster *"
                value={clusterValue || null}
                options={options}
                handleOnSelect={(value) => handleOnSelectChange(value)}
                isLoading={clusterApi.isLoading}
                isRequired={isRequired}
            />
        </Box>
    );
};

Cluster.propTypes = {
    order: PropTypes.object,
    clusterValue: PropTypes.string,
    handleOnSelect: PropTypes.func,
    isRequired: PropTypes.bool,
};

Cluster.defaultProps = {
    order: {},
    clusterValue: null,
    handleOnSelect: () => {},
    isRequired: false,
};

export default Cluster;
